import { render, staticRenderFns } from "./pc-guess.vue?vue&type=template&id=b86750ac&scoped=true"
import script from "./pc-guess.vue?vue&type=script&lang=js"
export * from "./pc-guess.vue?vue&type=script&lang=js"
import style0 from "./pc-guess.vue?vue&type=style&index=0&id=b86750ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86750ac",
  null
  
)

export default component.exports